var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91027 0.668034C8.35602 -0.222673 9.64395 -0.222682 10.0897 0.668034L12.2122 4.90925L16.9582 5.58936C17.955 5.73219 18.3529 6.94017 17.6317 7.63347L14.1974 10.9348L15.0082 15.5964C15.1784 16.5753 14.1365 17.3219 13.245 16.8597L8.99998 14.6588L4.75502 16.8597C3.86353 17.3219 2.82158 16.5753 2.99184 15.5964L3.80256 10.9348L0.368303 7.63347C-0.352937 6.94017 0.0450526 5.73219 1.04178 5.58936L5.78781 4.90925L7.91027 0.668034Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteOn);
export default __webpack_public_path__ + "static/media/FavoriteOn.f371b25b48894967056e08ae24b4df0c.svg";
export { ForwardRef as ReactComponent };